<!--

    Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
@if (resource() | hasLink: commandLinkRel.CREATED_BY) {
  <alfa-user-profile-in-historie-container
    [command]="resource()"
    class="username"
    data-test-class="user-profile-in-historie-item-header"
  />
} @else {
  <span
    class="border-grayborder dark:bg-grayborder relative mr-1.5 ml-0.5 flex size-6 shrink-0 items-center justify-center overflow-hidden rounded-full border dark:border-0"
  >
    <ods-icon name="logo" size="small" />
  </span>
  <span class="username" data-test-class="system-user-in-historie-item-header">Die Anwendung</span>
}
<p class="headline" data-test-class="historie-item-header">
  hat am <ods-date [date]="resource().createdAt" withTime="true" size="small" />
  {{ headline() }}
</p>
